<script setup lang="ts">
definePageMeta({
  layout: 'site',
  title: 'pages.site-about.title',
  description: 'pages.site-about.description',
})
</script>
<template>
  <main class="dvn-site-content">
    <section class="dvn-section-content">
      <h1>ABOUT US</h1>
    </section>
  </main>
</template>
